export const hashGenerate = (invoice) => {
  let cart = [];
  invoice.invoice.cart.map((product) => {
    cart.push(product.id);
    return null;
  });

  let hash = {
    a: invoice.invoice.customer.id,
    b: invoice.invoice.general_info.tipo_pagamento,
    c: invoice.invoice.general_info.valor_total,
    d: invoice.invoice.customer.email,
    e: cart,
  };

  hash = btoa(JSON.stringify(hash));

  return hash;
};
